import { Component } from '@angular/core';

@Component({
  selector: 'app-the-excellence-competition',
  templateUrl: './the-excellence-competition.component.html',
  styleUrl: './the-excellence-competition.component.scss'
})
export class TheExcellenceCompetitionComponent {

}
